<!--

  *------------------------ 使用手順 ------------------------*

  inputのnameを、
  ・画像ファイルのinputのname
  ・画像URLのinputのname
  でそれぞれ指定してください

  ・画像URLのinputのname
  に関しては、指定なしだとinputが非表示になります。
  適宜使い分けをしてください。

  ↓↓↓↓↓コードスニペット↓↓↓↓↓

  <preview-image-component
    init-input-url-name     = "URLインプットのname"
    init-input-image-name   = "画像インプットのname"
    init-image-url          = "{{ 既存の画像URL }}"
    init_cloud_front        = "{{ env('CLOUD_FRONT_DOMAIN') }}"
  >
  </preview-image-component>

-->
<template>
  <div class="preview_input_component inline-flex flex-col">

    <label for="img" class="image_label inline-flex items-center inline-flex justify-center">
      <!-- 画像変更ボタン -->
      <figure>
        <img v-bind:src="previewImageUrl" v-show="previewImageUrl" class="w-full"/>

        <!-- 画像アイコン -->
        <svg class="icon_style fill_theme" v-show="!previewImageUrl">
          <use xlink:href="/svg/symbol-defs.svg#icon-edit"/>
        </svg>
      </figure>

    </label>

    <!-- 画像インプット -->
    <input id="img" class="file_input" type="file" v-bind:name="inputImageName" v-on:change="setImage($event)"/>
    <input type="hidden" v-bind:name="inputUrlName" v-bind:value="inputImage" v-if="inputUrlName"/>

    <div class="inline-flex justify-between mt-[15px]">
      <label for="img" class="el_btn_white_largeBorder">講座画像を変更</label>
      <span class="el_btn_white_largeBorder ml-[30px]">リセット</span>
    </div>

  </div>
</template>

<script>

export default {
  props: ['initInputUrlName', 'initInputImageName', 'initImageUrl', 'initCloudFront'],
  data() {
    return {
      // inputのname
      inputUrlName:this.initInputUrlName,
      inputImageName:this.initInputImageName,
      // 画像URL
      previewImageUrl:this.initCloudFront+this.initImageUrl,
      // インプット用
      inputImage:this.initImageUrl

    };
  },
  methods: {
    /**
     * イベントリスナーからプレビューをセット
     */
    setImage(event)
    {
      // 中身がない場合処理終了

      if (event.target.files.length == 0) {
        return false
      }

      const file = (event.target.files || event.dataTransfer)[0];
      if (file.type.startsWith("image/")) {
        this.previewImageUrl = window.URL.createObjectURL(file);
        this.inputImage = this.previewImageUrl;
      }
    },
    /**
     * 画像の削除
     */
    deleteImage()
    {
      this.previewImageUrl  = "";
    },
  },
  mounted() {
  }
};
</script>

<style lang="scss" scoped>
$col_theme: #eb5d75;
$col_gray: #e9e9e9;
$col_grayDark: #999;
.preview_input_component{
  width: 100%;
//   height: 100%;
  .image_label{
    display: block;
    width: 100%;
    // height: 100%;
    margin-top: 0;
    border-radius: 4px;
    background: $col_grayDark;
    cursor: pointer;
  }
  .file_input{
    display: none;
  }
}
</style>
